module.exports = __webpack_public_path__ + "img/faculty-sarah.017e1381.png";